export default __webpack_public_path__ + "static/media/instructions-display-word.351ee09e.png";